import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useLocation } from "react-router-dom";
import { getUserId, setTempLanguage } from "../api/sessionManagement";

const UNAUTHORIZED_ROUTES = [
  "/sign-in",
  "/sign-up",
  "/recover-password",
  "/landing",
  "/shipping-quote",
  "/shipping-request",
  "/2fa",
  "/questionary",
  "/warranties",
];

export const useUnauthorizedLangFromUrl = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const handleLanguageChange = async () => {
      const userId = getUserId();
      if (userId) return;

      const isUnauthorizedRoute =
        UNAUTHORIZED_ROUTES.some((route) =>
          location.pathname.startsWith(route)
        ) || location.pathname.startsWith("/recover-password/");

      if (!isUnauthorizedRoute) return;

      const qLang = searchParams.get("lang");
      if (!qLang) return;

      const shortLang = qLang.split("-")[0];

      const supported = ["en", "ru", "et", "pl", "lt", "lv"];
      if (!supported.includes(shortLang)) return;

      if (i18n.language === shortLang) return;

      const allParams = Array.from(searchParams.keys());
      if (allParams.length > 1) return;

      try {
        setTempLanguage(qLang);
        await i18n.changeLanguage(qLang);
      } catch (error) {
        console.error(
          "Failed to change language from URL for unauthorized user:",
          error
        );
      }
    };

    if (i18n.isInitialized) {
      handleLanguageChange();
    }
  }, [searchParams, i18n, location.pathname]);
};
